export enum ERecentPartiesAction {
    CREATED = 'CREATED',
    UPDATED = 'UPDATED'
}